import {DefaultValues} from 'react-hook-form';

import {isNotNil} from 'ramda-adjunct';

import {GetEmployeeOrgranisationalDataSalesApiApiResponse} from '@dms/api/customer';

import {SALES_EMPTY_BRANCH} from '../../../constants/salesEmptyBranch';
import {EmployeeSalesOrganizationalForm} from '../types/EmployeeSalesOrganizationalForm';

export const getOrganizationPlacementFormDefaultValues = (
  data?: GetEmployeeOrgranisationalDataSalesApiApiResponse
): DefaultValues<EmployeeSalesOrganizationalForm> => ({
  companyId: data?.organisationalData?.companyId,
  note: data?.note ?? undefined,
  branches: data?.organisationalData?.branches?.map((branch) => ({
    branchId: branch?.branchId ?? undefined,
    professionId: branch?.professionId ?? undefined,
    authorizationIds:
      branch?.authorizations
        ?.filter(isNotNil)
        ?.map((authorization) => authorization.authorizationProfileId) ?? [],
  })) ?? [SALES_EMPTY_BRANCH],
});
